"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleHasPermission = roleHasPermission;
exports.hasAdminAccess = hasAdminAccess;
exports.hasSubmissionAccess = hasSubmissionAccess;
exports.hasCopywriterAccess = hasCopywriterAccess;
const roles_types_1 = require("./roles.types");
function roleHasPermission(permissionReq, assignedUserRoles, isProd) {
    if (!isProd && assignedUserRoles.includes('ENGINEER')) {
        return true;
    }
    if (assignedUserRoles.includes('SUPER_ADMIN')) {
        return true;
    }
    let allPermissionsOfUser = [];
    assignedUserRoles.forEach((userRole) => {
        const rolePermissions = roles_types_1.ROLE_PERMISSION_MAP[userRole] || [];
        allPermissionsOfUser = [...allPermissionsOfUser, ...rolePermissions];
    });
    return allPermissionsOfUser.includes(permissionReq);
}
function hasAdminAccess(roles) {
    for (const role of roles) {
        if (roles_types_1.ADMIN_ROLES.includes(role)) {
            return true;
        }
    }
    return false;
}
function hasSubmissionAccess(roles) {
    for (const role of roles) {
        if (roles_types_1.SUBMISSION_ROLES.includes(role)) {
            return true;
        }
    }
    return false;
}
function hasCopywriterAccess(roles) {
    for (const role of roles) {
        if (roles_types_1.COPYWRITER_ROLES.includes(role)) {
            return true;
        }
    }
    return false;
}
